import lodashCloneDeep from 'lodash/cloneDeep'

export const addFilesToUploadQueueActionType = 'addFilesToUploadQueueActionType';

export function addFilesToUploadQueueAction(queueItems) {
    return {
        type: addFilesToUploadQueueActionType,
        payload: {
            queueItems: queueItems
        }
    }
}

export function addFilesToUploadQueueHandler(state, action) {
    const { queueItems, tags } = action.payload;
    let newState = lodashCloneDeep(state);

    let queue = newState.queue;
    for (let queueItem of queueItems) {
        let index = queue.findIndex(function(existingQueueItem) {
            return queueItem.id == existingQueueItem.id;
        });
        if (index == -1) {
            queue.push(queueItem);
        } else {
            queue[index] = queueItem;
        }
    }
    return newState;
}
